class AnchorNav extends HTMLElement {
  connectedCallback() {
    this.headerEl = document.querySelector('.header-section header[is="sticky-header"]');
    this.links = Array.from(this.querySelectorAll('[data-anchor]'));
    this._boundHandleClick = this._handleClick.bind(this);
    this.links.forEach((link) => link.addEventListener('click', this._boundHandleClick));

    this._nav = this.querySelector('.brands-list__nav');
    if (this._nav) this._initDrag(this._nav);
  }

  disconnectedCallback() {
    this.links.forEach((link) => link.removeEventListener('click', this._boundHandleClick));
    if (this._nav) this._destroyDrag(this._nav);
  }

  _initDrag(el) {
    this._drag = { active: false, startX: 0, scrollLeft: 0, moved: false };
    el._onMouseDown = (e) => {
      this._drag.active = true;
      this._drag.moved = false;
      this._drag.startX = e.pageX - el.offsetLeft;
      this._drag.scrollLeft = el.scrollLeft;
      el.style.cursor = 'grabbing';
      el.style.userSelect = 'none';
    };
    el._onMouseMove = (e) => {
      if (!this._drag.active) return;
      const x = e.pageX - el.offsetLeft;
      const delta = x - this._drag.startX;
      if (Math.abs(delta) > 4) this._drag.moved = true;
      el.scrollLeft = this._drag.scrollLeft - delta;
    };
    el._onMouseUp = () => {
      this._drag.active = false;
      el.style.cursor = '';
      el.style.userSelect = '';
    };
    el.addEventListener('mousedown', el._onMouseDown);
    window.addEventListener('mousemove', el._onMouseMove);
    window.addEventListener('mouseup', el._onMouseUp);
  }

  _destroyDrag(el) {
    el.removeEventListener('mousedown', el._onMouseDown);
    window.removeEventListener('mousemove', el._onMouseMove);
    window.removeEventListener('mouseup', el._onMouseUp);
  }

  _getHeaderHeight(targetTop) {
    if (!this.headerEl) return 0;

    const height = Math.round(this.headerEl.offsetHeight);

    if (this.headerEl.dataset.stickyType === 'always') return height;

    const isPinned = document.body.classList.contains('header-pinned');
    if (isPinned) return height;

    if (targetTop < window.scrollY) return height;

    return 0;
  }

  _handleClick(event) {
    if (this._drag && this._drag.moved) return;
    event.preventDefault();
    const targetId = event.currentTarget.dataset.anchor;
    const target = document.querySelector(`[data-anchor-id=${targetId}]`);
    if (!target) return;

    const rawTop = target.getBoundingClientRect().top + window.scrollY;
    const headerHeight = this._getHeaderHeight(rawTop);
    const top = rawTop - headerHeight - 16;

    window.scrollTo({ top, behavior: 'smooth' });

    this.links.forEach((el) => el.classList.remove('brands-list__link--active'));
    event.currentTarget.classList.add('brands-list__link--active');

    target.setAttribute('pulse-animation', '');

    setTimeout(() => {
      target.removeAttribute('pulse-animation');
    }, 3000);
  }
}

customElements.define('anchor-nav', AnchorNav);
